import UpdateUserSettings from "@/settings/UpdateUserSettings.vue";

var base = require('settings/profile');

Vue.component('spark-profile', {
    components: {UpdateUserSettings},
    mixins: [base],
});
